import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from './icons/InfoIcon';
import { FileSearchOutlined } from '@ant-design/icons';
import { SectionIcon } from './SectionIcon';

// S11: the dealer could not provide a history; an outcome with what happens next, never an error page
export const Outcome = ({ outcome }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="outcome" className="card empty" aria-labelledby="outcome-title">
            <div className="empty-ic" aria-hidden="true">
                <InfoIcon color="#B8165F" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 720 }}>
                <h2 id="outcome-title" className="h2">
                    <SectionIcon icon={FileSearchOutlined} />
                    {outcome.title}
                </h2>
                <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--tokens-text-secondary)' }}>
                    {outcome.text}
                </p>
            </div>
            {outcome.credit && (
                <div className="credit">
                    <span className="eyebrow">{t('outcome.credit')}</span>
                    <span style={{ fontSize: 15, fontWeight: 600 }}>{outcome.credit}</span>
                </div>
            )}
            <div className="actions noprint" data-testid="outcome-actions">
                {outcome.onPrimary && (
                    <button type="button" className="btn btn-primary" onClick={outcome.onPrimary}>
                        {outcome.primary}
                    </button>
                )}
                {outcome.secondaryHref && (
                    <a className="btn btn-secondary" href={outcome.secondaryHref}>
                        {outcome.secondary}
                    </a>
                )}
            </div>
        </section>
    );
};
